import { useEffect } from 'react';

const APP_PREFIX = 'Cleany';

/**
 * Sets `document.title` to `Cleany - <title>` for the lifetime of the
 * component that calls this hook. Restores the previous title on unmount.
 *
 * @param {string | null | undefined} title The title fragment to append after
 * the "Cleany - " prefix. When falsy, `document.title` is reset to the default
 * app name.
 */
const useDocumentTitle = (title) => {
  useEffect(() => {
    const previous = document.title;

    if (title) {
      document.title = `${APP_PREFIX} - ${title}`;
    } else {
      document.title = APP_PREFIX;
    }

    return () => {
      document.title = previous;
    };
  }, [title]);
};

export default useDocumentTitle;
